import { css } from 'lit';

export const planeConnectionBarStyles = css`
  :host {
    display: block;
  }

  :host([hidden]) {
    display: none;
  }

  .bar {
    background: var(--tone-warning-soft);
    color: var(--tone-warning);
    border-bottom: var(--border-width) solid var(--tone-warning);
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-semibold);
    text-align: center;
    padding: var(--space-2) calc(var(--space-5) + var(--safe-right)) var(--space-2) calc(var(--space-5) + var(--safe-left));
  }
`;
